module.exports = __webpack_public_path__ + "img/IMG-20200311-WA0112.634623d8.jpg";